'use strict';

var formValidation = require('../../../../../../app_storefront_base/cartridge/client/default/js/components/formValidation');
var createErrorNotification = require('../../../../../../app_storefront_base/cartridge/client/default/js/components/errorNotification');

module.exports = {
    register: function () {
        $('form.js-address-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.js-address-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);

                        if(data.message) {
                            form.prepend('<div class="alert alert-danger js-login-incorrect-alert">'
                            + data.message + '</div>');
                        }

                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        //window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },
};